// export default process.env.NODE_ENV === 'production' || process.env.WAYUP !== 'false'
//   ? process.env.WAYUP !== 'false'
//     ? 'https://datascience-worker.herokuapp.com/api'
//     : '/api'
//   : 'http://localhost:3001/api'

export default 'https://datascience-worker.herokuapp.com/api'
